import { DatePreset } from 'app/components/datepicker-dropdown/enums';

const API_PERIOD_PRESETS = new Set([
  'this_week',
  'last_week',
  'this_month',
  'last_month',
  'this_quarter',
  'last_quarter',
  'this_year',
  'last_year',
  'last_7_days',
  'last_30_days',
  'last_90_days',
  'custom',
]);

export function mapCreateReportPeriodPreset(
  datePreset: string | null,
): 'custom' | string {
  if (datePreset && API_PERIOD_PRESETS.has(datePreset)) {
    return datePreset;
  }
  return 'custom';
}

export function isSupportedReportPeriodPreset(
  preset: string,
): preset is DatePreset {
  return API_PERIOD_PRESETS.has(preset);
}
